module.exports = __webpack_public_path__ + "img/1567016095.084208a8.jpg";